// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M6.66797 6.66602H6.6763M1.66797 4.33268L1.66797 8.06144C1.66797 8.4691 1.66797 8.67292 1.71402 8.86473C1.75485 9.03479 1.82219 9.19737 1.91357 9.34649C2.01664 9.51468 2.16076 9.65881 2.44902 9.94706L8.83954 16.3376C9.82958 17.3276 10.3246 17.8226 10.8954 18.0081C11.3975 18.1713 11.9384 18.1713 12.4405 18.0081C13.0113 17.8226 13.5064 17.3276 14.4964 16.3376L16.3395 14.4944C17.3296 13.5044 17.8246 13.0094 18.0101 12.4386C18.1732 11.9364 18.1732 11.3956 18.0101 10.8935C17.8246 10.3227 17.3296 9.82763 16.3395 8.83759L9.94902 2.44706C9.66076 2.15881 9.51664 2.01468 9.34844 1.91162C9.19932 1.82023 9.03675 1.75289 8.86669 1.71207C8.67487 1.66602 8.47105 1.66602 8.0634 1.66602L4.33464 1.66602C3.40122 1.66602 2.9345 1.66602 2.57799 1.84767C2.26438 2.00746 2.00941 2.26243 1.84963 2.57603C1.66797 2.93255 1.66797 3.39926 1.66797 4.33268ZM7.08464 6.66602C7.08464 6.89613 6.89809 7.08268 6.66797 7.08268C6.43785 7.08268 6.2513 6.89613 6.2513 6.66602C6.2513 6.4359 6.43785 6.24935 6.66797 6.24935C6.89809 6.24935 7.08464 6.4359 7.08464 6.66602Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const IconTag = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconTag;
